import SolutionPageTemplate from "../components/SolutionPageTemplate";
import logistics from "../Accets/logistics.jpg";

export default function LogisticsSolutions() {
  return (
    <SolutionPageTemplate
      title="Logistics Solutions"
      subtitle="Optimize logistics operations with secure digital payments, automated settlements, real-time tracking integrations, and intelligent financial workflows."

      image={logistics}

      challenges={[
        {
          title: "Delayed Freight Payments",
          description:
            "Slow payment cycles impact cash flow for transporters, suppliers, and delivery partners.",
        },
        {
          title: "Complex Vendor Management",
          description:
            "Managing multiple logistics partners and verifying their credentials can be time-consuming.",
        },
        {
          title: "Manual Settlement Process",
          description:
            "Manual reconciliation and settlements increase operational costs and cause delays.",
        },
        {
          title: "Limited Visibility",
          description:
            "Lack of real-time shipment and payment tracking affects operational efficiency.",
        },
      ]}

      features={[
        {
          title: "Instant Freight Payments",
          description:
            "Process payments instantly to transporters, drivers, and logistics partners.",
        },
        {
          title: "Vendor KYC Verification",
          description:
            "Digitally verify logistics vendors for faster onboarding and compliance.",
        },
        {
          title: "Automated Settlements",
          description:
            "Automatically reconcile transactions and settle payments without manual effort.",
        },
        {
          title: "Real-Time Tracking APIs",
          description:
            "Integrate shipment tracking and payment status into one unified platform.",
        },
        {
          title: "Bulk Payouts",
          description:
            "Disburse payments to multiple drivers, warehouses, or suppliers in a single transaction.",
        },
        {
          title: "Analytics Dashboard",
          description:
            "Monitor deliveries, settlements, payment history, and operational performance from one dashboard.",
        },
      ]}

      benefits={[
        {
          title: "Faster Payment Cycles",
          description:
            "Reduce settlement times and improve cash flow across your logistics network.",
        },
        {
          title: "Operational Efficiency",
          description:
            "Automate manual financial workflows and eliminate reconciliation delays.",
        },
        {
          title: "Enterprise-Grade Security",
          description:
            "Protect transactions with secure APIs, encryption, and compliance standards.",
        },
        {
          title: "Scalable Infrastructure",
          description:
            "Support growing delivery volumes with reliable cloud-based fintech solutions.",
        },
      ]}

      industries={[
        "Courier Services",
        "Freight & Transport",
        "Warehouse Management",
        "Supply Chain",
      ]}

      faqs={[
        {
          question: "Can I automate vendor payments?",
          answer:
            "Yes. Our APIs automate payouts and settlements to logistics partners, drivers, and vendors.",
        },
        {
          question: "Does the platform support bulk payouts?",
          answer:
            "Absolutely. Bulk payout APIs allow businesses to transfer funds securely to multiple recipients at once.",
        },
        {
          question: "Can I integrate shipment tracking?",
          answer:
            "Yes. Our APIs integrate seamlessly with logistics platforms to provide real-time shipment and payment visibility.",
        },
        {
          question: "Is the platform secure?",
          answer:
            "Yes. We use enterprise-grade encryption, secure APIs, and compliance standards to protect every transaction.",
        },
      ]}
    />
  );
}